import { render, staticRenderFns } from "./ValueDisplay.vue?vue&type=template&id=6abd6c22&scoped=true"
import script from "./ValueDisplay.vue?vue&type=script&lang=js"
export * from "./ValueDisplay.vue?vue&type=script&lang=js"
import style0 from "./ValueDisplay.vue?vue&type=style&index=0&id=6abd6c22&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6abd6c22",
  null
  
)

export default component.exports